import React from 'react';

import { Box, Typography } from '@mui/material';

import type { ReportTitleProperties } from './ReportTitle.types';

/**
 * Заголовок инвестиционного отчета с названием проекта
 */
export const ReportTitle: React.FC<ReportTitleProperties> = ({
  projectName,
  sx,
  dataTest = 'report_title',
}) => {
  return (
    <Box sx={sx} data-testid={dataTest}>
      <Typography
        variant='h3'
        component='h1'
        data-testid={`${dataTest}_text`}
        sx={{
          fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
          letterSpacing: '-0.03em',
          fontWeight: 500,
          color: 'text.primary',
          lineHeight: 1.2,
        }}
      >
        Инвестиционный анализ проекта{' '}
        <Box
          component='span'
          data-testid={`${dataTest}_project_name`}
          sx={{
            color: 'primary.main',
            fontWeight: 700,
            display: { xs: 'block', md: 'inline' },
            mt: { xs: 1, md: 0 },
          }}
        >
          {projectName}
        </Box>
      </Typography>
    </Box>
  );
};
